// Screenname:Category master
// Developer Name: Jagadish.
// Created date on: 2 / 2 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages: 
import httpbaseURL from '../common/axios';
class Categoryservices {
    createdata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/ProductTypeMAS/Create", doc)
    }
    getdata() {
        return httpbaseURL.httpMSInventoryUrl.get("/ProductTypeMAS/List")
    }
    getProductStartValue() {
        return httpbaseURL.httpMSInventoryUrl.get("/ProductTypeMAS/GetProductStartValue")
    }
    GetCategory(Id) {
        return httpbaseURL.httpMSInventoryUrl.get("/ItemStoreMappingMAP/GetByStoreId?StoreId=" + Id)
    }
    getfindonedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.get("/ProductTypeMAS/Get?id=" + doc)
    }
    updatedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.post("/ProductTypeMAS/Update", doc)
    }
    deletedata(doc) {
        return httpbaseURL.httpMSInventoryUrl.delete("/ProductTypeMAS/Delete?id=" + doc)
    }
    active(doc, Status) {
        debugger;
        return httpbaseURL.httpMSInventoryUrl.put(
            "/ProductTypeMAS/Active?id=" + doc + "&Status=" + Status + ""
        );
    }
}
export default new Categoryservices()